// extracted by mini-css-extract-plugin
export default {"nosotros":"Nosotros_nosotros__+uSlW"};